module.exports = __webpack_public_path__ + "static/media/20151105_122411_2_small_xs.aa6dc3b4.jpg";